import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FreelancersService} from '../../freelancers/freelancers.service';
import {StatisticsService} from '../../statistics/statistics.service';
import {Awss3UploadService} from '../awss3-upload.service';
import {AppConstants} from '../app.constants';
import {ManagersService} from '../../managers/managers.service';
import {StoreService} from '../../stores/store.service';
import {BrandService} from '../../brands/brand.service';
import {PotentialService} from '../../potentials/potential.service';
import {InvoiceService} from '../../invoices/invoice.service';
import {SmsBlastService} from '../../sms-blast/sms-blast.service';
import {CandidateService} from '../../candidates/candidate.service';
import {AvailabiltyService} from '../../availabilities/availabilty.service';
import {ShiftsService} from '../../shifts/shifts.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    FreelancersService,
    StatisticsService,
    AppConstants,
    Awss3UploadService,
    ManagersService,
    StoreService,
    BrandService,
    PotentialService,
    InvoiceService,
    SmsBlastService,
    CandidateService,
    AvailabiltyService,
    ShiftsService,
  ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shared/core/core.module.ts